import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  Divider,
  MenuItem,
  TextField,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  Button,
  ListItemText,
  IconButton,
  CssBaseline,
  ThemeProvider,
  AppBar,
  Toolbar,
  Drawer,
  Tabs,
  Tab,
  ListItemSecondaryAction,
} from "@material-ui/core";
import * as React from "react";
import { colors } from "../constants/constants";
import { EventEmitter } from "../events/EventEmitter";
import { CompaniesService } from "../services/CompaniesService";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import { AppContext, AuthConsumer } from "../routes/AuthContext";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import UploadIcon from "@material-ui/icons/Backup";
import HasPermission from "../auth/HasPermission";
import { DropzoneDialog } from "material-ui-dropzone";
import { FileManagementService } from "../services/FileManagementService";
import DescriptionIcon from "@material-ui/icons/Description";
import DeleteIcon from "@material-ui/icons/Delete";
import GenericDialog from "./GenericDialog";
import emptyTrash from "../assets/images/empty_trash.png";
import { types } from "./AddCompanyDialog";
import { defaultTheme } from "../utils/theme";
import TabPanel from "../components/TabPanel";
import LoadingComponents from "../components/LoadingComponents";
import HasMutablePermission from "../auth/HasMutablePermission";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ConfigurationService } from "../services/ConfigurationService";
const drawerWidth = 220;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      display: "flex",
      height: 224,
    },
    mRoot: {
      width: '100%',
    },
    tabs: {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    appBar: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
    drawerPaper: {
      marginTop: 64,
      width: drawerWidth,
    },
    button: { margin: theme.spacing(2) },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    gridList: {
      width: "100%",
      height: "auto",
    },
    image: {
      width: 128,
      height: 128,
    },
    tabRoot: {
      flexGrow: 1,
    },
    fab: {
      position: "fixed",
      zIndex: 100,
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    section3: {
      margin: theme.spacing(3, 3, 3),
    },
    chip: {
      margin: theme.spacing(0.5),
    },
    signChip: {
      padding: 5,
      margin: 5,
      width: 120,
      height: 44,
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },

    control: {
      padding: theme.spacing(1) * 2,
    },
    icon: {
      color: "rgba(255, 255, 255, 0.54)",
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    list: {
      width: "100%",
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  onClose: any;
  company?: any;
}
class FileManagmentDialog extends React.Component<Props> {
  state = {
    companies: Array<any>(),
    selectedCompany: { _id: "", name: "" },
    selected: {},
    openDropZoneDialog: false,
    openConfirmationDialog: false,
    filesDropZoneFiles: new Array<any>(),
    fileNames: new Array<any>(),
    fileHowToNames: new Array<any>(),
    selectedTab: 0,
    selectedFileToDelete: "",
    isLoading: false,

    howToDocumentationSelectedFileToDelete: "",
    openHowToDropZoneDialog: false,
    openHowToDocumentationConfirmationDialog: false,
    selectedTabValue: 0,
  };

  handleClose = () => {
    this.setState({
      openDropZoneDialog: false,
      openConfirmationDialog: false,
      openHowToDropZoneDialog: false,
      openHowToDocumentationConfirmationDialog: false
    });
  };

  handleListItemClick = () => { };

  componentDidMount = () => {
    if (this.props.company) {
      this.setState(
        {
          selectedCompany: this.props.company,
        },
        () => {
          this.getFileName(this.state.selectedCompany.name);
        }
      );
    } else {
      this.getCompanies();
    }
    this.getHowFileName();
  };

  componentDidUpdate = (prevProps: any) => {
    if (prevProps.company !== this.props.company) {
      if (this.props.company) {
        this.setState(
          {
            selectedCompany: this.props.company,
          },
          () => {
            this.getFileName(this.state.selectedCompany.name);
          }
        );
      } else {
        this.getCompanies();
      }
    }
  };

  getCompanies = () => {
    let companiesService: CompaniesService = new CompaniesService();
    this.setState({
      isLoading: true,
    });
    companiesService.getCompanies().then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.companies) {
        this.setState(
          {
            companies: resp.companies,
          },
          () => {
            let contextState = this.context;
            let user = contextState && contextState.user ? contextState.user : null;
            if (user) {
              let belongsToCompany = this.belongToCompany(user);
              if (belongsToCompany) {
                this.setState(
                  {
                    selectedCompany: belongsToCompany,
                  },
                  () => {
                    this.getFileName(this.state.selectedCompany.name);
                  }
                );
              }
            }
          }
        );
      } else {
        this.setState({
          showCompanies: false,
          showToolBarButton: false,
        });
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        }
      }
    });
  };

  getFileName = (companyName: any) => {
    let fileManagementService: FileManagementService = new FileManagementService();
    this.setState({
      isLoading: true,
    });
    fileManagementService.getFileName(companyName).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.names) {
        this.setState({
          fileNames: resp.names,
        });
      } else {
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: "Oops something wrong happened.",
          });
        }
      }
    });
  };

  getHowFileName = () => {
    let configurationService: ConfigurationService = new ConfigurationService();
    this.setState({
      isLoading: true,
    });
    configurationService.getFileName().then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.names) {
        this.setState({
          fileHowToNames: resp.names,
        });
      } else {
        if (resp && resp.message) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: "Oops something wrong happened.",
          });
        }
      }
    });
  };

  downloadFile = (fileName: any, companyName: any) => {
    let fileManagementService: FileManagementService = new FileManagementService();
    this.setState({
      isLoading: true,
    });
    fileManagementService
      .downloadFile(fileName, companyName)
      .then((resp: any) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        } else {
          var url = window.URL.createObjectURL(resp);
          var a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove();
        }
      });
  };

  downloadHowToDcumentsFile = (fileName: any) => {
    let configurationService: ConfigurationService = new ConfigurationService();
    this.setState({
      isLoading: true,
    });
    configurationService
      .downloadFile(fileName)
      .then((resp: any) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            show: true,
            type: SNACKBAR_TYPE.ERROR,
            message: resp.message,
          });
        } else {
          var url = window.URL.createObjectURL(resp);
          var a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove();
        }
      });
  };

  downloadAll = (companyName: any) => {
    let fileManagementService: FileManagementService = new FileManagementService();
    this.setState({
      isLoading: true,
    });
    fileManagementService.downloadAll(companyName).then((resp: any) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          show: true,
          type: SNACKBAR_TYPE.ERROR,
          message: resp.message,
        });
      } else {
        var url = window.URL.createObjectURL(resp);
        var a = document.createElement("a");
        a.href = url;
        a.download = "templates-all.zip";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
      }
    });
  };

  handleSelectedItem = (event: any) => {
    let value = event.target.value;
    let selectedCompany = this.state.companies.filter((company: any) => {
      return company.name === value;
    });
    if (selectedCompany && selectedCompany.length > 0) {
      this.setState(
        {
          selectedCompany: selectedCompany[0],
        },
        () => {
          this.getFileName(this.state.selectedCompany.name);
        }
      );
    }
  };

  belongToCompany = (user: any) => {
    if (
      this.state.companies &&
      this.state.companies.length > 0 &&
      user.companyId
    ) {
      let filtered = this.state.companies.filter((company: any) => {
        return company._id === user.companyId;
      });
      if (filtered.length > 0) {
        return filtered[0];
      }
    }
    if (this.props.company) {
      return this.props.company;
    }
    return null;
  };

  handleOnDropdownChanged = (selected: any) => {
    this.setState(
      {
        openDropZoneDialog: true,
        selected: selected,
      },
      () => {
        this.getFileName(selected);
      }
    );
  };

  renderDropZoneDialog = () => {
    return (
      <DropzoneDialog
        open={this.state.openDropZoneDialog}
        onSave={this.handleDropZoneSaveFiles.bind(this)}
        showPreviews={true}
        acceptedFiles={[".xlsx"]}
        maxFileSize={5000000}
        onClose={this.handleClose.bind(this)}
      />
    );
  };
  renderHowToDocumentationDropZoneDialog = () => {
    return (
      <DropzoneDialog
        open={this.state.openHowToDropZoneDialog}
        onSave={this.handleHowToDocumentationDropZoneSaveFiles.bind(this)}
        showPreviews={true}
        acceptedFiles={[".pdf", ".docx", ".doc", ".pptx"]}
        maxFileSize={5000000}
        onClose={this.handleClose.bind(this)}
      />
    );
  };
  checkFileName = (files: any) => {
    let fileNameOk = true;
    files.map((file: any) => {
      let isOk =
        (file.name
          .toLowerCase()
          .includes(this.state.selectedCompany.name.toLowerCase()) &&
          file.name.toLowerCase().includes("Employees".toLowerCase())) ||
        file.name.toLowerCase().includes("Checklists".toLowerCase());
      if (!isOk) {
        fileNameOk = false;
      }

      return null;
    });
    return fileNameOk;
  };
  handleDropZoneSaveFiles = (files: any) => {
    let selected: any = this.state.selected;
    if (selected.name) {
      let fileManagementService: FileManagementService = new FileManagementService();
      this.setState({
        isLoading: true,
      });
      fileManagementService.uploadFile(files, selected.name).then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "File(s) uploaded successfully",
          });
          this.setState(
            {
              openDropZoneDialog: false,
            },
            () => {
              this.getFileName(this.state.selectedCompany.name);
            }
          );
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        }
      });
    } else {
      EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
        type: SNACKBAR_TYPE.ERROR,
        show: true,
        message: "Please select a company",
      });
    }
  };

  handleHowToDocumentationDropZoneSaveFiles = (files: any) => {
    let configurationService: ConfigurationService = new ConfigurationService();
    this.setState({
      isLoading: true,
    });
    configurationService.uploadFile(files).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "File(s) uploaded successfully",
        });
        this.setState(
          {
            openHowToDropZoneDialog: false,
          },
          () => {
            this.getHowFileName();
          }
        );
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  handleConfirmedDelete = () => {
    let fileManagementService: FileManagementService = new FileManagementService();
    this.setState({
      isLoading: true,
    });
    fileManagementService
      .deleteFile(
        this.state.selectedFileToDelete,
        this.state.selectedCompany.name
      )
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        this.setState({ isLoading: false });
        if (resp && resp.success) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully",
          });
          this.setState({ openConfirmationDialog: false }, () => {
            this.getFileName(this.state.selectedCompany.name);
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something happened",
          });
        }
      });
  };


  handleHowToDocumentationConfirmedDelete = () => {
    let configurationService: ConfigurationService = new ConfigurationService();
    this.setState({
      isLoading: true,
    });
    configurationService
      .deleteFile(
        this.state.howToDocumentationSelectedFileToDelete,
      )
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        this.setState({ isLoading: false });
        if (resp && resp.success) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.SUCCESS,
            show: true,
            message: "Deleted Successfully",
          });
          this.setState({ openHowToDocumentationConfirmationDialog: false }, () => {
            this.getHowFileName();
          });
        } else if (resp && resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something happend.",
          });
        }
      });
  };


  // handleDownloadFile = (fileName: any) => {
  //   var link = document.createElement("a");
  //   let url =
  //   if (typeof link.download === "string") {
  //     document.body.appendChild(link); //Firefox requires the link to be in the body
  //     link.download = fileName;
  //     link.href = url;
  //     link.click();
  //     document.body.removeChild(link); //remove the link when done
  //   } else {
  //     document.location.replace(url);
  //   }
  // };

  handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ selectedTab: newValue });
  };
  handleTabValueChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ selectedTabValue: newValue });
  };

  renderConfirmationDialog = () => {
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting ${this.state.selectedFileToDelete}`}
        message={
          "Are you sure want to delete " + this.state.selectedFileToDelete
        }
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };
  renderHowToDocumentationConfirmationDialog = () => {
    return <Dialog
      open={this.state.openHowToDocumentationConfirmationDialog}
      onClose={() => this.handleClose()}
      fullWidth={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {`Deleting ${this.state.howToDocumentationSelectedFileToDelete}`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Are you sure want to delete ${this.state.howToDocumentationSelectedFileToDelete}`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => this.handleClose()} color="primary">
          Cancel
          </Button>
        <Button onClick={() => this.handleHowToDocumentationConfirmedDelete()} color="primary">
          Yes
          </Button>
      </DialogActions>
    </Dialog>
  };

  renderConfirm = () => {
    return (
      <Dialog
        open={this.state.openConfirmationDialog}
        onClose={() => this.handleClose()}
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Deleting ${this.state.selectedFileToDelete}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure want to delete ${this.state.selectedFileToDelete}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.handleClose()} color="primary">
            Cancel
          </Button>
          <Button onClick={() => this.handleConfirmedDelete()} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const { open, onClose, classes } = this.props;
    return (
      <React.Fragment>
        {this.renderDropZoneDialog()}
        {this.renderHowToDocumentationDropZoneDialog()}
        {this.renderConfirm()}
        {this.renderHowToDocumentationConfirmationDialog()}
        <AuthConsumer>
          {({ user, accessRules }) => {
            let belongsToCompany = this.belongToCompany(user);
            return (
              <Dialog
                fullScreen
                onClose={() => onClose()}
                aria-labelledby="simple-dialog-title"
                open={open}
              >
                <LoadingComponents isLoading={this.state.isLoading} />
                <div className={classes.root}>
                  <CssBaseline />
                  <ThemeProvider theme={defaultTheme}>
                    <AppBar position="fixed">
                      <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                          Help and Templates
                        </Typography>
                        {this.state.selectedTab === 0 &&
                          < div
                            style={{
                              display: "flex",
                              flex: 1,
                              justifyContent: "flex-end",
                            }}
                          >
                            {belongsToCompany ? (
                              <TextField
                                id="filled-select-currency"
                                style={{ color: "black", flex: 0.5 }}
                                label="Company"
                                value={belongsToCompany.name}
                                variant="outlined"
                              ></TextField>
                            ) : (
                                <TextField
                                  id="filled-select-currency"
                                  select
                                  style={{ color: "black", flex: 0.5 }}
                                  label="Select company"
                                  value={
                                    this.state.selectedCompany
                                      ? this.state.selectedCompany.name
                                      : ""
                                  }
                                  onChange={this.handleSelectedItem}
                                  variant="outlined"
                                >
                                  {this.state.companies &&
                                    this.state.companies.map(
                                      (company: any, index: any) => (
                                        <MenuItem
                                          key={index.toString()}
                                          value={company.name ? company.name : ""}
                                        >
                                          {company.name}
                                        </MenuItem>
                                      )
                                    )}
                                </TextField>
                              )}
                          </div>
                        }

                        <Button
                          style={{
                            marginLeft: 20,
                          }}
                          onClick={() => onClose()}
                        >
                          Close
                        </Button>
                      </Toolbar>
                    </AppBar>
                  </ThemeProvider>
                  <Drawer
                    className={classes.drawer}
                    variant="permanent"
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                    anchor="left"
                  >
                    <Divider />
                    <div style={{ overflow: "auto" }}>
                      <div
                        style={{
                          margin: 20,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Tabs
                          orientation="vertical"
                          variant="scrollable"
                          value={this.state.selectedTab}
                          onChange={this.handleTabChange}
                          aria-label="Vertical tabs example"
                          className={classes.tabs}
                        >
                          <Tab label="Templates" />
                          <Tab label="Help" />
                        </Tabs>
                      </div>
                    </div>
                  </Drawer>

                  <main className={classes.content}>
                    <div className={classes.toolbar} />

                    <React.Fragment>
                      <TabPanel value={this.state.selectedTab} index={0}>
                        {this.state.selectedCompany &&
                          this.state.selectedCompany.name ? (
                            <div
                              style={{
                                display: "flex",
                                flex: 1,
                                flexDirection: "column",
                                overflow: "auto",
                              }}
                            >
                              <Tabs
                                value={this.state.selectedTabValue}
                                onChange={this.handleTabValueChange}
                                textColor="primary"
                                TabIndicatorProps={{
                                  style: { background: "orange", height: 3 },
                                }}
                              >
                                {HasMutablePermission({
                                  role: user.role,
                                  data: user.role,
                                  accessRules: accessRules,
                                  perform: "templates:upload",
                                }) ? (
                                    <Tab label="Upload Templates" />
                                  ) : null}
                                {HasMutablePermission({
                                  role: user.role,
                                  data: user.role,
                                  accessRules: accessRules,
                                  perform: "templates:download",
                                }) ? (
                                    <Tab label="Download Templates" />
                                  ) : null}
                              </Tabs>
                              {HasMutablePermission({
                                role: user.role,
                                data: user.role,
                                accessRules: accessRules,
                                perform: "templates:upload",
                              }) ? (
                                  <TabPanel
                                    value={this.state.selectedTabValue}
                                    index={0}
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        overflow: "auto",
                                      }}
                                    >
                                      <HasPermission
                                        role={user.role}
                                        accessRules={accessRules}
                                        perform="templates:upload"
                                        data={user.role}
                                        yes={() => (
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              flex: 1,
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                flex: 1,
                                              }}
                                            >
                                              <Typography
                                                style={{ marginTop: 10, marginBottom: 10 }}
                                                variant="h5"
                                                component="h5"
                                              >
                                                Upload Templates
                                              </Typography>
                                              <Button
                                                style={{ marginTop: 10, marginBottom: 10 }}
                                                startIcon={<UploadIcon />}
                                                color="secondary"
                                                onClick={() => {
                                                  this.setState({
                                                    openDropZoneDialog: true,
                                                    selected: this.state
                                                      .selectedCompany,
                                                  });
                                                }}
                                              >
                                                Upload
                                        </Button>
                                            </div>
                                            <Divider />
                                            <ListItemText
                                              primary="Upload the bulk upload templates. Please make sure that the name for each file is unique, files with the same name will be replaced."
                                              secondaryTypographyProps={{
                                                color: "secondary",
                                              }}
                                              secondary={
                                                "Please refer to the Help page for naming rules."
                                              }
                                            />
                                            <List dense={true}>
                                              {this.state.fileNames.map((name, index: any) => (
                                                <div key={index.toString() + "files-upload-templates-download"}>
                                                  <ListItem>
                                                    <ListItemAvatar>
                                                      <Avatar>
                                                        <DescriptionIcon />
                                                      </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={name} />
                                                    <ListItemSecondaryAction>
                                                      <IconButton
                                                        edge="end"
                                                        aria-label="delete"
                                                        onClick={() => {
                                                          this.setState({
                                                            selectedFileToDelete: name,
                                                            openConfirmationDialog: true,
                                                          });
                                                        }}
                                                      >
                                                        <DeleteIcon />
                                                      </IconButton>
                                                    </ListItemSecondaryAction>
                                                  </ListItem>
                                                  <Divider
                                                    variant="inset"
                                                    component="li"
                                                  />
                                                </div>
                                              ))}
                                            </List>
                                          </div>
                                        )}
                                      ></HasPermission>
                                    </div>
                                  </TabPanel>
                                ) : null}
                              {HasMutablePermission({
                                role: user.role,
                                data: user.role,
                                accessRules: accessRules,
                                perform: "templates:download",
                              }) ? (
                                  <TabPanel
                                    value={this.state.selectedTabValue}
                                    index={
                                      HasMutablePermission({
                                        role: user.role,
                                        data: user.role,
                                        accessRules: accessRules,
                                        perform: "templates:upload",
                                      })
                                        ? 1
                                        : 0
                                    }
                                  >
                                    <div
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        overflow: "auto",
                                      }}
                                    >
                                      <HasPermission
                                        role={user.role}
                                        accessRules={accessRules}
                                        perform="templates:download"
                                        data={user.role}
                                        yes={() => (
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <Typography
                                                style={{ marginTop: 10, marginBottom: 10 }}
                                                variant="h5"
                                                component="h5"
                                              >
                                                Download Templates
                                        </Typography>
                                              <Button
                                                startIcon={<DownloadIcon />}
                                                color="secondary"
                                                onClick={() =>
                                                  this.downloadAll(
                                                    this.state.selectedCompany.name
                                                  )
                                                }
                                              >
                                                All
                                        </Button>
                                            </div>
                                            <Divider />
                                            <Typography
                                              style={{ marginTop: 10, marginBottom: 10 }}
                                              variant="subtitle1"
                                              gutterBottom
                                            >
                                              Download employees or checklists using
                                              the bulk upload file.
                                      </Typography>
                                            <List dense={true}>
                                              {this.state.fileNames.map((name, index: any) => (
                                                <div key={index.toString() + "upload-templates-download"}>
                                                  <ListItem>
                                                    <ListItemAvatar>
                                                      <Avatar>
                                                        <DescriptionIcon />
                                                      </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText primary={name} />
                                                    <ListItemSecondaryAction>
                                                      <IconButton
                                                        edge="end"
                                                        aria-label="delete"
                                                        onClick={() => {
                                                          this.downloadFile(
                                                            name,
                                                            this.state.selectedCompany
                                                              .name
                                                          );
                                                        }}
                                                      >
                                                        <DownloadIcon />
                                                      </IconButton>
                                                    </ListItemSecondaryAction>
                                                  </ListItem>
                                                  <Divider
                                                    variant="inset"
                                                    component="li"
                                                  />
                                                </div>
                                              ))}
                                            </List>
                                          </div>
                                        )}
                                      ></HasPermission>
                                    </div>
                                  </TabPanel>
                                ) : null}
                            </div>
                          ) : <div
                            style={{
                              height: 500,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              overflow: "auto",
                            }}
                          >
                            <img
                              src={emptyTrash}
                              style={{ width: 40, height: 40 }}
                              alt="Empty Trash"
                            />
                            <Typography
                              variant="h5"
                              gutterBottom
                              style={{ marginTop: 10, textAlign: "center" }}
                            >
                              {"Select a company".toUpperCase()}
                            </Typography>
                          </div>}
                      </TabPanel>
                      <TabPanel value={this.state.selectedTab} index={1}>
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            overflow: "auto",
                          }}
                        >
                          <HasPermission
                            role={user.role}
                            accessRules={accessRules}
                            perform="documents:upload"
                            data={user.role}
                            yes={() => (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  flex: 1,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    flex: 1,
                                  }}
                                >
                                  <Typography
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                    variant="h5"
                                    component="h5"
                                  >
                                    Upload how to documentation
                                  </Typography>
                                  <Button
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                    startIcon={<UploadIcon />}
                                    color="secondary"
                                    onClick={() => {
                                      this.setState({
                                        openHowToDropZoneDialog: true,
                                      });
                                    }}
                                  >
                                    Upload
                                        </Button>
                                </div>
                                <Divider />
                                <ListItemText
                                  primary="Upload the how to documentation."
                                  secondaryTypographyProps={{
                                    color: "secondary",
                                  }}
                                  secondary={"preferable pdf files"}
                                />
                                <List dense={true}>
                                  {this.state.fileHowToNames.map((name, index: any) => (
                                    <div key={index.toString() + "files-download"}>
                                      <ListItem>
                                        <ListItemAvatar>
                                          <Avatar>
                                            <DescriptionIcon />
                                          </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={name} />
                                        <ListItemSecondaryAction>
                                          <IconButton
                                            edge="end"
                                            aria-label="delete"
                                            onClick={() => {
                                              this.setState({
                                                howToDocumentationSelectedFileToDelete: name,
                                                openHowToDocumentationConfirmationDialog: true,
                                              });
                                            }}
                                          >
                                            <DeleteIcon />
                                          </IconButton>
                                        </ListItemSecondaryAction>
                                      </ListItem>
                                      <Divider
                                        variant="inset"
                                        component="li"
                                      />
                                    </div>
                                  ))}
                                </List>
                              </div>
                            )}
                          ></HasPermission>
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              overflow: "auto",
                            }}
                          >
                            <HasPermission
                              role={user.role}
                              accessRules={accessRules}
                              perform="documents:download"
                              data={user.role}
                              yes={() => (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <Typography
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                    variant="h5"
                                    component="h5"
                                  >
                                    Download how to documents
                                  </Typography>
                                  <Divider />
                                  <Typography
                                    style={{ marginTop: 10, marginBottom: 10 }}
                                    variant="subtitle1"
                                    gutterBottom
                                  >
                                    Download the how documentation below for help.
                                  </Typography>
                                  <List dense={true}>
                                    {this.state.fileHowToNames.map((name, index: any) => (
                                      <div key={index.toString() + "upload-templates-download"}>
                                        <ListItem>
                                          <ListItemAvatar>
                                            <Avatar>
                                              <DescriptionIcon />
                                            </Avatar>
                                          </ListItemAvatar>
                                          <ListItemText primary={name} />
                                          <ListItemSecondaryAction>
                                            <IconButton
                                              edge="end"
                                              aria-label="delete"
                                              onClick={() => {
                                                this.downloadHowToDcumentsFile(
                                                  name,
                                                );
                                              }}
                                            >
                                              <DownloadIcon />
                                            </IconButton>
                                          </ListItemSecondaryAction>
                                        </ListItem>
                                        <Divider
                                          variant="inset"
                                          component="li"
                                        />
                                      </div>
                                    ))}
                                  </List>
                                </div>)}
                              no={() => (
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                  <Typography
                                    variant="h5"
                                    gutterBottom
                                    style={{ marginTop: 10, textAlign: "center" }}
                                  >
                                    {"Not permitted".toUpperCase()}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    gutterBottom
                                    style={{ marginTop: 10, textAlign: "center" }}
                                  >
                                    {"Please contact the admistrator to help you."}
                                  </Typography>
                                </div>
                              )}
                            ></HasPermission>
                          </div>
                        </div>
                      </TabPanel>
                    </React.Fragment>

                  </main>
                </div>
              </Dialog>
            );
          }}
        </AuthConsumer>
      </React.Fragment >
    );
  }
}
FileManagmentDialog.contextType = AppContext;
export default withStyles(styles)(FileManagmentDialog);
